<template>
	<div>
		<sui-modal v-model="open" size="small">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont">{{ titulo }}</strong>
				</slot>
				<i style="float: right; cursor: pointer;" class="close icon" @click="close"></i>
			</sui-modal-header>
			<sui-modal-content>
				<sui-modal-description>
					<sui-header>
						<sui-grid>
							<sui-grid-row>
								<sui-grid-column :width="12">
									<strong class="boldFont nine-wide">{{ plantillaDescripcion }}</strong>
								</sui-grid-column>
								<sui-grid-column :width="4">
									<a :href="plantilla" download>
										<BaseButton
											style-button="primary"
											style="margin: 10px;"
											style-class="right floated tiny basic"
										>
											<i class="file alternate icon" style="color: #1b396a !important"></i>
											<span style="color: #1b396a !important">Plantilla</span>
										</BaseButton>
									</a>
								</sui-grid-column>
							</sui-grid-row>
						</sui-grid>
					</sui-header>
				</sui-modal-description>
				<span v-if="informacionExtra !== ''" style="color: #5c5d5d !important; font-size: 14px;">{{informacionExtra}}</span>
				<br v-else />
				<BaseArchivo
					titulo="Subir Archivo"
					subtitulo="Arrastre o seleccione el archivo aquí"
					:value="value"
					:open="open"
					@input="archivos"
				/>
				<div v-if="noHayArchivos" :class="$style.dangerColor">
					<i class="info circle icon"></i>
					Es necesario seleccionar/arrastrar un archivo
				</div>
			</sui-modal-content>
			<sui-modal-actions style="padding: 0 !important;">
				<BaseButton
					style-button="primary"
					style="margin: 10px"
					:loading="loading"
					style-class="right floated"
					@click.native="toggle"
					@click="aceptar"
				>Subir</BaseButton>
			</sui-modal-actions>
		</sui-modal>
	</div>
</template>
<script>
import Notification from '@utils/notification';
export default {
	props: {
		titulo: {
			type: String,
			default: 'Agregar ...'
		},
		plantilla: {
			type: String,
			default: ''
		},
		loading: {
			type: Boolean,
			default: false
		},
		plantillaDescripcion: {
			type: String,
			default: 'Descargue el formato CSV para agregar nuevos ...'
		},
		value: {
			type: [FileList, Array],
			default: () => []
		},
		informacionExtra: {
			type: String,
			default: ''
		}
	},
	data() {
		return { open: false, archivosl: [], noHayArchivos: false, files: [] };
	},
	mounted() {
		this.noHayArchivos = false;
	},
	methods: {
		toggle() {
			if (this.open) {
				if (this.archivosl.length <= 0) {
					// this.noHayArchivos = true;
					return Notification(
						'error',
						'Es necesario seleccionar/arrastrar un archivo'
					);
				}
				const archivo = this.archivosl[0];
				if (!this.validarTamanio(archivo)) {
					Notification(
						'error',
						'El archivo excede el tamaño permitido. Máximo 10MB.'
					);
					// this.noHayArchivos = false;
					this.archivos([]);
					return;
				}
				if (!this.validarTipo(archivo)) {
					Notification('error', 'Solo se permiten archivos CSV');
					// this.noHayArchivos = false;
					this.archivos([]);
					return;
				}
				this.$emit('aceptar');
				// this.noHayArchivos = false;
				this.archivos([]);
			} else {
				this.open = !this.open;
			}
		},
		close() {
			this.noHayArchivos = false;
			this.open = false;
		},
		archivos(files) {
			this.archivosl = files;
			this.$emit('input', files);
		},
		aceptar() {},
		validarTamanio(archivo) {
			return archivo.size / 1024 / 1024 <= 10;
		},
		validarTipo(archivo) {
			return (
				archivo.type === 'application/vnd.ms-excel' ||
				archivo.type === 'text/csv' ||
				archivo.name.indexOf('.csv')
			);
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
.dangerColor {
	margin-top: 10px;
	color: $background-danger;
}

.blueColor {
	color: $background-primary !important;
}
</style>
